export enum EQueryOperator {
  Contains = 'contains',
  Equal = 'eq',
  NotEqual = 'nq',
  GreaterThan = 'gt',
  GreaterThanOrEqual = 'ge',
  LessThan = 'lt',
  LessThanOrEqual = 'le',
}
